import useAxios from 'axios-hooks';

export interface IName {
  nameEn: string;
  nameTh: string;
}

export interface IInfoCategoryMasterData extends IName {
  id: number;
  infoCategory: string;
  infoCategoryMasterDataId?: number;
  codeDataPlatform?: string;
  sequence: number;
}

export enum infoCategory {
  STAKEHOLDER = 'stakeholder',
  COMMUNICATION_ACTIVITY = 'communication_activity',
}

const masterDataPath = '/master-data';

export const useGetInfoCategoryMasterData = (
  infoCategory: string | string[]
) => {
  return useAxios<IInfoCategoryMasterData[]>({
    url: `${masterDataPath}/info-category?infoCategories=${infoCategory.toString()}`,
    method: 'GET',
  });
};

export const useGetCountryMasterData = (infoCategory: string) => {
  return useAxios<IInfoCategoryMasterData[]>({
    url: `${masterDataPath}/country/${infoCategory}`,
    method: 'GET',
  });
};
